// src/theme/atomic/pink.ts
var pink = {
  10: "#3D0133",
  20: "#730560",
  30: "#A81690",
  40: "#D331B8",
  50: "#F553DA",
  60: "#FA73E3",
  70: "#FF94ED",
  80: "#FFB8F3",
  90: "#FED3F7",
  95: "#FEECFB",
  99: "#FFFAFE"
};
var pink_default = pink;

export { pink_default as default };
